















































































































































































import { Component, Vue } from "vue-property-decorator";
import HeaderComponent from "@/components/layout/HeaderComponent.vue";
import MainComponent from "@/components/layout/MainComponent.vue";
import SidebarComponent from "@/components/layout/SidebarComponent.vue";
import ContentComponent from "@/components/layout/ContentComponent.vue";
import SidebarContentHeaderComponent from "@/components/layout/SidebarContentHeaderComponent.vue";
import MenubarComponent from "@/components/layout/MenubarComponent.vue";
import CircleComponent from "@/components/common/figures/CircleComponent.vue";
import SensorDetailComponent from "@/components/common/parts/SensorDetailComponent.vue";
import FooterComponent from "@/components/layout/FooterComponent.vue";
import { THRESHOLDS } from "@/config/thresholds";
import isOverThreshold from "@/typescript/lib/common/is_over_threshold";
import { isSideIpad } from "@/typescript/lib/common/is_ipad";
import { getDetailPosition } from "@/typescript/components/common/parts/sensor_detail_component/functions";
import { TempSample } from "@/typescript/pages/temp_managements/index.ts";
import { getRoutePath } from "@/router/routes";
import { storeMenus } from "@/config/store_menus";
import { getEquipmentIcon } from "@/typescript/lib/common/get_equipment_icon";
import { getAlertData } from "@/typescript/lib/common/get_alert_data";
import { TempManagementsInfo } from "@/typescript/pages/temp_managements/types";
import { GetStoreSensorsResponse } from "../../typescript/api_client/emesh_api/stores/types";
import { SensorDetail } from "@/typescript/components/common/parts/sensor_detail_component/types";
import { getStoreSensorsApi } from "../../typescript/api_client/emesh_api/stores/store_sensors_api";
import { getEquipmentsMeasurementApi } from "../../typescript/api_client/emesh_api/equipments/equipments_measurement_api";
import { getEquipmentsApi } from "@/typescript/api_client/emesh_api/equipments/equipments_api";
import { getCircleColor } from "@/typescript/components/common/figures/circle_component/functions";
import { convertNullObject } from "@/typescript/lib/common/convert_null_object";
import { fillZero } from "@/typescript/lib/common/fill_zero";
import { AlertData } from "../../typescript/lib/common/types";
export {
  TempSample,
  TempManagementsInfo,
  GetStoreSensorsResponse,
  SensorDetail,
  AlertData
};

// どの温度がどの色に該当するかを表すサンプル Circle のサイズ
const sampleCircleSize: string = "14px";

// 最新値に表示を更新する間隔(秒)
const DISPLAY_UPDATE_INTERVAL: number = 60 * 1000;

@Component({
  components: {
    HeaderComponent,
    MainComponent,
    SidebarComponent,
    ContentComponent,
    SidebarContentHeaderComponent,
    MenubarComponent,
    CircleComponent,
    SensorDetailComponent,
    FooterComponent
  }
})
export default class TempManagementsImagePage extends Vue {
  $refs!: {
    content_component: Vue;
  };
  tempManagementInfos: TempManagementsInfo[] = [];
  currentDetailSensor: SensorDetail | {} = {};
  detailPosition: string = "left-detail";
  detailPositionStyle: string = "106%";
  storeName: string = "";

  tempSamples: TempSample[] = [
    {
      color: 0,
      size: sampleCircleSize,
      value_start: THRESHOLDS[0],
      value_end: THRESHOLDS[1]
    },
    {
      color: 1,
      size: sampleCircleSize,
      value_start: THRESHOLDS[1],
      value_end: THRESHOLDS[2]
    },
    {
      color: 2,
      size: sampleCircleSize,
      value_start: THRESHOLDS[2],
      value_end: THRESHOLDS[3]
    },
    {
      color: 3,
      size: sampleCircleSize,
      value_start: THRESHOLDS[3],
      value_end: THRESHOLDS[4]
    }
  ];

  // API 取得時の初期表示用判別フラグ
  isInitialDisplay: boolean = false;

  // 最新値に表示を更新するタイマーID
  displayUpdateTimerId: number = 0;

  created() {
    this.isInitialDisplay = true;
    this.$store.commit("setActiveId", {
      activeId: storeMenus().find(
        m => m.pageName === "TempManagementsImagePage"
      )?.id
    });
    this.setTempManagementInfos();
    this.displayUpdateTimerId = setInterval(() => {
      this.setTempManagementInfos();
    }, DISPLAY_UPDATE_INTERVAL);
  }

  destroyed() {
    if (this.displayUpdateTimerId) {
      clearInterval(this.displayUpdateTimerId);
    }
  }

  get isPopupOpend() {
    return Object.keys(this.currentDetailSensor).length > 0;
  }

  async getSensorData(
    equipmentId: string
  ): Promise<{
    temperature: string;
    alertStatus: number;
    alerts: AlertData[];
    battery: number | null;
    receiveBLESensitivity: number | null;
  }> {
    return await getEquipmentsMeasurementApi({
      equipment_id: equipmentId
    }).then(resp => {
      const temperature = resp.measurement_data[0]
        ? resp.measurement_data[0].temperature
        : "--";
      const battery = resp.measurement_data[0]
        ? resp.measurement_data[0].battery
        : null;
      const recieveSensitivity = resp.measurement_data[0]
        ? resp.measurement_data[0].receive_sensitivity
        : null;
      return {
        temperature: temperature,
        alerts: resp.alerts.map(a =>
          getAlertData(a.alert_id, resp.status as 0 | 1 | 2)
        ),
        alertStatus: resp.status,
        battery: battery,
        // null の場合はアイコンを without にしたいため、 -100 を代入する
        receiveBLESensitivity:
          recieveSensitivity === null
            ? -100
            : resp.measurement_data[0].receive_sensitivity
      };
    });
  }

  async getEquipment(
    equipmentId: string
  ): Promise<{
    iconKind: number;
    guardTime: number;
    serialNo: string;
    snoozingTime: number;
    locationNo: string;
  }> {
    return await getEquipmentsApi(equipmentId).then(resp => {
      return {
        iconKind: resp.icon_kind,
        guardTime: resp.guard_time,
        serialNo: resp.serial_no,
        snoozingTime: resp.snoozing_time,
        locationNo:
          resp.location_no === null ? "00" : fillZero(resp.location_no, 2)
      };
    });
  }

  async makeTempManagementInfos() {
    const storeSensors = await getStoreSensorsApi(
      this.$route.params.store_id
    ).then((resp: GetStoreSensorsResponse) => {
      return resp;
    });

    this.storeName = storeSensors.store_name;

    this.$store.commit("setStoreInfo", {
      storeId: storeSensors.store_id,
      storeName: storeSensors.store_name
    });

    return Promise.all(
      storeSensors.sensors.map(async sensor => {
        const sensorData = await this.getSensorData(sensor.equipment_id);
        const equipment = await this.getEquipment(sensor.equipment_id);
        const res = {
          alertStatus: sensorData.alertStatus,
          alerts: sensorData.alerts,
          battery: sensorData.battery,
          equipmentId: sensor.equipment_id,
          equipmentName: sensor.equipment_name,
          guardTime: equipment.guardTime,
          iconKind: equipment.iconKind,
          lowerLimit: sensor.lower_limit,
          receiveBLESensitivity: sensorData.receiveBLESensitivity,
          serialNo: equipment.serialNo,
          snoozingTime: equipment.snoozingTime,
          temperature: sensorData.temperature,
          upperLimit: sensor.upper_limit,
          locationNo: equipment.locationNo
        };
        return convertNullObject(res, "--", [
          "equipmentName",
          "guardTime",
          "lowerLimit",
          "serialNo",
          "upperLimit"
        ]);
      })
    );
  }

  close() {
    this.currentDetailSensor = {};
  }

  setTempManagementInfos() {
    this.makeTempManagementInfos().then(resp => {
      this.tempManagementInfos = resp.sort(
        (a, b) => a.lowerLimit - b.lowerLimit
      ) as TempManagementsInfo[];
      // 初期表示をオフにする
      this.isInitialDisplay = false;
    });
  }

  getColor(thHigh: number): number {
    return getCircleColor(thHigh);
  }

  getWarningImage(status: 0 | 1 | 2, temp: string | "DEF", alerts): string {
    if (this.isDefForWarningImage(temp, alerts)) return "";
    if (status === 1) return "/images/icons/ic_common_warning02.png";
    if (status === 2) return "/images/icons/ic_common_warning01.png";
    return "";
  }

  getCategoryImage(iconNum: number, status: "on" | "off"): string {
    return getEquipmentIcon(iconNum, status);
  }

  isOverThreshold(ctTemp: string, thLow: string, thHigh: string): boolean {
    if (ctTemp === "DEF") return false;
    return isOverThreshold(Number(ctTemp), Number(thLow), Number(thHigh));
  }

  isSideIpad(): boolean {
    return isSideIpad();
  }

  getListPagePath() {
    return getRoutePath("TempManagementsListPage", {
      store_id: this.$route.params.store_id
    });
  }

  showDetail(sensor: SensorDetail, event: MouseEvent) {
    this.currentDetailSensor = sensor;
    const width = event.currentTarget
      ? (event.currentTarget as HTMLTextAreaElement).offsetWidth
      : 144;
    const clientX = event.currentTarget
      ? (event.currentTarget as HTMLTextAreaElement).getBoundingClientRect().x
      : event.clientX;
    if (!this.$refs.content_component) return;
    this.detailPosition = getDetailPosition(
      this.$refs.content_component.$el.clientWidth,
      width,
      clientX
    );
  }

  isError(temp: string | "ERROR") {
    return temp === "ERROR";
  }

  isDef(temp: string | "DEF") {
    return temp === "DEF";
  }

  // 2021.09.21
  // センサ右上に表示される警報！判定
  // 温度異常でDEFの場合は表示しない
  isDefForWarningImage(temp: string | "DEF", alerts) {
    if (this.isDef(temp) === false) return false;
    for (let i = 1; i < alerts.length; i++) {
      if (alerts[i].id !== "OE00000001" && alerts[i].id !== "OE00000002")
        return false;
    }
    return true;
  }
}
